import {useRef, useState} from "react";
import {agent} from "../api/agent";
import {useNavigate} from "react-router-dom";
import Input from "./Input";
import Button from "./Button";
import styled from "styled-components";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1rem;
    background-color: var(--content-box-bg);

    input {
        margin: 1rem .5rem;
    }

    h1 {
        margin: 1rem .5rem;
    }

`;

const Center = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
`;

export default function Login() {

    const usernameRef = useRef<HTMLInputElement>(null);
    const passwordRef = useRef<HTMLInputElement>(null);

    const navigate = useNavigate();
    const [isChangingPassword, setIsChangingPassword] = useState<boolean>(false);

    const login = () => {
        agent.login(usernameRef.current!.value, passwordRef.current!.value).then(value => {
            localStorage.setItem('token', value.session as unknown as string);
            //save token as a cookie
            document.cookie = `token=${value.session}; path=/; max-age=2592000`;
            //window.location.reload();
            if (value.requirePasswordChange) {
                setIsChangingPassword(true);
                return;
            }
            navigate('/');
        }).catch(error => {
            console.error('Login error:', error);
            alert('Login failed: ' + error.error);
        })
    }

    const changePassword = () => {
        if (!isChangingPassword) {
            return;
        }
        if (usernameRef.current!.value !== passwordRef.current!.value) {
            alert('Passwords do not match');
            return;
        }
        agent.loginUpdate(passwordRef.current!.value).then(() => {
            alert('Password changed successfully');
            navigate('/');
        }).catch(error => {
            console.error('Change password error:', error);
            alert('Change password failed: ' + error.message);
        });
    }

    return (<Center>
        <Container>
            {!isChangingPassword && (
                <>
                    <h1>Login</h1>
                    <Input type={"text"} ref={usernameRef} placeholder={'username'}/>
                    <Input type={"password"} ref={passwordRef} placeholder={'password'} onReturnPress={() => login()}/>
                    <Button onClick={() => login()} className={'primary'}>Login</Button>
                </>
            )}
            { isChangingPassword && (
                <>
                    <h1>Change your password</h1>
                    <Input type={"password"} ref={usernameRef} placeholder={'password'}/>
                    <Input type={"password"} ref={passwordRef} placeholder={'password confirm'} onReturnPress={() => changePassword()}/>
                    <Button onClick={() => changePassword()} className={'primary'}>Update</Button>
                </>
                )}
        </Container>
    </Center>);
}